export enum ExtrasSsrsEnum {
  PRIORITY_AIRPORT_CHECK_IN = 'CKIP',
  AIRPORT_CHECK_IN = 'CKIF',
  FAST_TRACK = 'FAST',
  AMENITY_KIT = 'AKIP',
  PRIORITY_BOARDING = 'PRBD',
  CARBON_OFFSET = 'PDCO',
  MY_LOUNGE = 'LNGE',
  TAPAS_PLATTER = 'TAPA',
  OSL_LOUNGE = 'LOSL',
  MCO_LOUNGE = 'LMCO',
  CDG_LOUNGE = 'LCDG',
  JFK_LOUNGE = 'LJFK',
  MBJ_LOUNGE = 'LMBJ',
  BKK_LOUNGE = 'LBKK',
  FCO_LOUNGE = 'LFCO',
  ARN_LOUNGE = 'LARN',
  FAST_TRACK_PASSPORT_CONTROL = 'FTPC',
}

export enum AncillaryAvailableEnum {
  OUTBOUND = 'Outbound',
  RETURN = 'Return',
  BOTH = 'Both',
}